export function formatTimeGroupConfig({
               getNow,
               formatDay,
               formatDate,
               addDate,
               inTimeRange,
               parseTime,
               isOnline,
               menuCode,
               parseDate,
               DayPanel,
               info = {},
           }) {
    const BetweenHour = (start, end) => () => {
        const h = getNow().getHours();
        return h >= start && h < end;
    };
    const Between = (start, end) => d => inTimeRange([start, end], d);
    const formatTime = t => formatDate(t, 'hh:mm:ss');
    const inRange = (target, min, max) => target >= min && target <= max;

    // 调试模式
    let debugMode = false;
    const inJmt = window.location.hostname.indexOf('jmt') !== -1;

    if (isOnline || inJmt || window.location.hostname === 'test007.fe.jd.com') {
        // 线上环境、预发环境和jmt环境不开启
        debugMode = false;
    } else if (window.location.hostname.indexOf('local') !== -1) {
        // 本地环境开启
        debugMode = true;
    } else if (window.GEP_USER_INFO) {
        // 通过白名单开启
        const {pin} = window.GEP_USER_INFO;
        const whiteList = new Set([
            // 'zuobai',
            // 'dubinghui',
            // 'zhangjianyu3',
            // 'qiujinlong',
            // 'yuanhuili',
            // 'longchenxu',
            // 'huangqingyao1',
            // 'zengxi1',
            // 'wangnan157',
            // 'zhouyongyan',
            // 'zhaotonghui1',
            // 'xingsijia1',
            // 'gongjiaman1',
            // 'mashuang31',
            // 'jiangyixuan1',
            // 'caiwanru',
            // 'huangye1',
            // 'sunbingqing1',
            // 'songmin41',
            // 'pengchengming',
            // 'yinhanwen1',
            // 'wangjing889',
        ]);
        debugMode = whiteList.has(pin);
    }

    const showOpen_door_aggr =
        (info?.demotion !== true && new Set(['deptRealTime', 'summaryRealTime']).has(menuCode)) ||
        inJmt;

    const specialCustomCompare = () => ({
        props: {
            ...DayPanel,
            isDateDisabled: date => {
                const today = getNow();
                const yoy = addDate(today, -1, 'year');
                return (
                    !inRange(date, addDate(today, -33, 'day'), addDate(today, -3, 'day')) && // 近31天
                    !inRange(date, parseDate('2022-05-23'), parseDate('2022-06-20')) && // 去年618大促季
                    !inRange(date, parseDate('2021-10-20'), parseDate('2021-11-14')) && // 去年双11大促季
                    !inRange(date, addDate(yoy, -31, 'day'), addDate(yoy, 31, 'day')) // 同比日期 X-31 ~ X+31
                );
            },
            defaultPickerValue: (() => {
                const yoy = addDate(getNow(), -1, 'year');
                return [yoy.getFullYear(), yoy.getMonth() + 1];
            })(),
        },
        tips: '支持选择近31天（不含昨日、前日）、同比对应的2个月、及上两个大促期间2022.5.23~2022.6.20、2021.10.20~2021.11.14的时间，快速计算自定义的对比数据。',
    });

    return {
        debugMode,

        disableAll: info?.[`${menuCode}_refresh`] === false,

        // 零点刷新随机数
        refreshDayRandom: () => (Math.random() * 20000) << 0,

        // 快捷选项
        operations: [
            {
                label: '今日累计',
                key: 'today_aggr',
                // 选项对应的时间值和对比时间值
                value(now = getNow()) {
                    return {
                        realtime: {
                            key: 'today',
                            day: formatDay(now),
                            value: ['00:00:00', formatTime(now)],
                            type: 'rangeTime',
                        },
                    };
                },
            },
            {
                label: '昨日累计',
                key: 'yesterday_aggr',
                value(now = getNow()) {
                    const yesterday = addDate(now, -1, 'day');

                    return {
                        realtime: {
                            key: 'yesterday',
                            day: formatDay(yesterday),
                            value: ['00:00:00', '23:59:59'],
                            type: 'rangeTime',
                        },
                    };
                },
            },
            {
                divider: true,
            },
            {
                label: '28h环比',
                key: 'hb_28h',
                // 选项显示条件
                isShown: BetweenHour(0, 20),
                // 显示选项描述
                description: () => {
                    const now = getNow();
                    return [
                        {
                            current: true,
                            range: [
                                formatDate(now, 'YYYY-MM-DD 00:00:00'),
                                formatDate(now, 'YYYY-MM-DD 20:00:00'),
                            ],
                        },
                    ];
                },
                value(now = getNow()) {
                    const yesterday = addDate(now, -1, 'day');

                    return {
                        realtime: {
                            key: 'custom',
                            day: formatDay(now),
                            value: [
                                [formatDay(yesterday), '20:00:00'],
                                [formatDay(now), formatTime(now)],
                            ],
                            type: 'rangeDayTime',
                        },
                    };
                },
                // 选择该选项时，启用特殊对比
                specialCustomCompare,
                // 显示“荐”的条件
                recommend: [
                    Between('2022-10-21 00:00:00', '2022-10-21 20:00:00'),
                    Between('2022-10-22 00:00:00', '2022-10-22 20:00:00'),
                    Between('2022-10-23 00:00:00', '2022-10-23 20:00:00'),
                    Between('2022-10-24 00:00:00', '2022-10-24 20:00:00'),
                    Between('2022-10-25 00:00:00', '2022-10-25 20:00:00'),
                    Between('2022-10-26 00:00:00', '2022-10-26 20:00:00'),
                    Between('2022-10-27 00:00:00', '2022-10-27 20:00:00'),
                    Between('2022-10-28 00:00:00', '2022-10-28 20:00:00'),
                    Between('2022-10-29 00:00:00', '2022-10-29 20:00:00'),
                    Between('2022-10-30 00:00:00', '2022-10-30 20:00:00'),
                    Between('2022-10-31 00:00:00', '2022-10-31 20:00:00'),
                    Between('2022-11-01 00:00:00', '2022-11-01 20:00:00'),
                    Between('2022-11-11 00:00:00', '2022-11-11 20:00:00'),
                ],
            },
            // {
            //     label: '28h同比',
            //     key: 'tb_28h',
            //     // 选项显示条件
            //     isShown: BetweenHour(0, 20),
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            //     // 选择该选项时，启用特殊对比
            //     specialCustomCompare,
            //     // 显示“荐”的条件
            //     recommend: [
            //         Between('2022-10-21 00:00:00', '2022-10-21 20:00:00'),
            //         Between('2022-10-22 00:00:00', '2022-10-22 20:00:00'),
            //         Between('2022-10-23 00:00:00', '2022-10-23 20:00:00'),
            //         Between('2022-10-24 00:00:00', '2022-10-24 20:00:00'),
            //         Between('2022-10-25 00:00:00', '2022-10-25 20:00:00'),
            //         Between('2022-10-26 00:00:00', '2022-10-26 20:00:00'),
            //         Between('2022-10-27 00:00:00', '2022-10-27 20:00:00'),
            //         Between('2022-10-28 00:00:00', '2022-10-28 20:00:00'),
            //         Between('2022-10-29 00:00:00', '2022-10-29 20:00:00'),
            //         Between('2022-10-30 00:00:00', '2022-10-30 20:00:00'),
            //         Between('2022-10-31 00:00:00', '2022-10-31 20:00:00'),
            //         Between('2022-11-01 00:00:00', '2022-11-01 20:00:00'),
            //         Between('2022-11-11 00:00:00', '2022-11-11 20:00:00'),
            //     ],
            // },
            // {
            //     label: '28h同比（今日晚8至今）',
            //     key: 'tb_28h_today',
            //     isShown: BetweenHour(20, 24),
            //     specialCustomCompare,
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     recommend: [
            //         Between('2022-10-20 20:00:00', '2022-10-21 00:00:00'),
            //         Between('2022-10-21 20:00:00', '2022-10-22 00:00:00'),
            //         Between('2022-10-22 20:00:00', '2022-10-23 00:00:00'),
            //         Between('2022-10-23 20:00:00', '2022-10-24 00:00:00'),
            //         Between('2022-10-24 20:00:00', '2022-10-25 00:00:00'),
            //         Between('2022-10-25 20:00:00', '2022-10-26 00:00:00'),
            //         Between('2022-10-26 20:00:00', '2022-10-27 00:00:00'),
            //         Between('2022-10-27 20:00:00', '2022-10-28 00:00:00'),
            //         Between('2022-10-28 20:00:00', '2022-10-29 00:00:00'),
            //         Between('2022-10-29 20:00:00', '2022-10-30 00:00:00'),
            //         Between('2022-10-30 20:00:00', '2022-10-31 00:00:00'),
            //         Between('2022-10-31 20:00:00', '2022-11-01 00:00:00'),
            //         Between('2022-11-10 20:00:00', '2022-11-11 00:00:00'),
            //     ],
            //     value(now = getNow()) {
            //         return {
            //             realtime: {
            //                 key: 'today',
            //                 day: formatDay(now),
            //                 value: ['20:00:00', formatTime(now)],
            //                 type: 'rangeTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '28h同比（昨日晚8至今）',
            //     key: 'tb_28h_yesterday',
            //     specialCustomCompare,
            //     recommend: [
            //         Between('2022-11-01 20:00:00', '2022-11-02 00:00:00'),
            //         Between('2022-11-11 20:00:00', '2022-11-12 00:00:00'),
            //     ],
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     isShown: BetweenHour(20, 24),
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '错位24h同比',
            //     key: 'record_24h',
            //     recommend: [
            //         Between('2022-11-02 20:00:00', '2022-11-03 00:00:00'),
            //         Between('2022-11-03 00:00:00', '2022-11-04 00:00:00'),
            //         Between('2022-11-04 00:00:00', '2022-11-05 00:00:00'),
            //         Between('2022-11-05 00:00:00', '2022-11-06 00:00:00'),
            //         Between('2022-11-06 00:00:00', '2022-11-07 00:00:00'),
            //         Between('2022-11-07 00:00:00', '2022-11-08 00:00:00'),
            //         Between('2022-11-08 00:00:00', '2022-11-09 00:00:00'),
            //         Between('2022-11-09 00:00:00', '2022-11-10 00:00:00'),
            //     ],
            //     specialCustomCompare,
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: true,
            //                 ahead: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 19:59:59'),
            //                 ],
            //             },
            //             {
            //                 current: true,
            //                 ahead: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //         const ahead4h = addDate(now, 4, 'hour');
            //         const yoy = addDate(ahead4h, -1, 'year');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(now.getHours() >= 20 ? now : yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTime: {
            //                 key: 'customCompare',
            //                 type: 'rangeDayTime',
            //                 value: [
            //                     [formatDay(yoy), '00:00:00'],
            //                     [formatDay(yoy), formatTime(yoy)],
            //                 ],
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '错位28h同比',
            //     key: 'mismatch_tb_28h',
            //     isShown: BetweenHour(0, 20),
            //     specialCustomCompare,
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 ahead: true,
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 05:59:59'),
            //                 ],
            //             },
            //             {
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 06:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //         const ahead4h = addDate(now, 4, 'hour');
            //         const yoy = addDate(ahead4h, -1, 'year');
            //         const h = now.getHours();
            //         const ahead = h < 6;
            //
            //         const realtime = {
            //             key: 'custom',
            //             day: formatDay(now),
            //             value: [
            //                 [formatDay(yesterday), '20:00:00'],
            //                 [formatDay(now), formatTime(now)],
            //             ],
            //             type: 'rangeDayTime',
            //         };
            //
            //         if (ahead) {
            //             realtime.valueKey = 'ahead';
            //             return {
            //                 realtime,
            //                 compareTime: {
            //                     key: 'customCompare',
            //                     type: 'rangeDayTime',
            //                     value: [
            //                         [formatDay(yoy), '00:00:00'],
            //                         [formatDay(yoy), formatTime(yoy)],
            //                     ],
            //                 },
            //             };
            //         }
            //         return {
            //             realtime,
            //         };
            //     },
            // },
            // {
            //     label: '错位28h同比（今日晚8至今）',
            //     key: 'mismatch_tb_28h_today',
            //     isShown: BetweenHour(20, 24),
            //     specialCustomCompare,
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 ahead: true,
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const ahead4h = addDate(now, 4, 'hour');
            //         const yoy = addDate(ahead4h, -1, 'year');
            //
            //         return {
            //             realtime: {
            //                 key: 'today',
            //                 day: formatDay(now),
            //                 value: ['20:00:00', formatTime(now)],
            //                 type: 'rangeTime',
            //             },
            //             compareTime: {
            //                 key: 'customCompare',
            //                 type: 'rangeDayTime',
            //                 value: [
            //                     [formatDay(yoy), '00:00:00'],
            //                     [formatDay(yoy), formatTime(yoy)],
            //                 ],
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '错位28h同比（昨日晚8至今）',
            //     key: 'mismatch_tb_28h_yesterday',
            //     isShown: BetweenHour(20, 24),
            //     specialCustomCompare,
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     divider: true,
            // },
            // {
            //     label: '28h回放',
            //     key: 'record_28h',
            //     recommend: [
            //         Between('2022-11-02 00:00:00', '2022-11-02 20:00:00'),
            //         Between('2022-11-12 00:00:00', '2022-11-13 00:00:00'),
            //     ],
            //     promptList: [
            //         {
            //             key: '20221102_record_28h',
            //             isShown: Between('2022-11-02 00:00:00', '2022-11-02 05:00:00'),
            //             message: '上一个28h活动已结束，是否快速回看活动整体数据？',
            //         },
            //         {
            //             key: '20221112_record_28h',
            //             isShown: Between('2022-11-12 00:00:00', '2022-11-12 05:00:00'),
            //             message: '上一个28h活动已结束，是否快速回看活动整体数据？',
            //         },
            //     ],
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const dayBeforeYesterday = addDate(now, -2, 'day');
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(yesterday),
            //                 value: [
            //                     [formatDay(dayBeforeYesterday), '20:00:00'],
            //                     [formatDay(yesterday), '23:59:59'],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '错位24h回放',
            //     key: 'mismatch_record_24h',
            //     recommend: [
            //         Between('2022-11-04 00:00:00', '2022-11-04 20:00:00'),
            //         Between('2022-11-05 00:00:00', '2022-11-05 20:00:00'),
            //         Between('2022-11-06 00:00:00', '2022-11-06 20:00:00'),
            //         Between('2022-11-07 00:00:00', '2022-11-07 20:00:00'),
            //         Between('2022-11-08 00:00:00', '2022-11-08 20:00:00'),
            //         Between('2022-11-09 00:00:00', '2022-11-09 20:00:00'),
            //         Between('2022-11-10 00:00:00', '2022-11-10 20:00:00'),
            //     ],
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 ahead: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 19:59:59'),
            //                 ],
            //             },
            //             {
            //                 ahead: true,
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 20:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const diff = now.getHours() >= 20 ? 0 : -1;
            //         const theDay = parseTime(`${formatDay(addDate(now, diff, 'day'))} 20:00:00`);
            //         const dayBeforeTheDay = addDate(theDay, -1, 'day');
            //         const ahead4h = addDate(dayBeforeTheDay, 4, 'hour');
            //         const yoy = addDate(ahead4h, -1, 'year');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(theDay),
            //                 value: [
            //                     [formatDay(dayBeforeTheDay), '20:00:00'],
            //                     [formatDay(theDay), '19:59:59'],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTime: {
            //                 key: 'customCompare',
            //                 type: 'rangeDayTime',
            //                 value: [
            //                     [formatDay(yoy), '00:00:00'],
            //                     [formatDay(yoy), '23:59:59'],
            //                 ],
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '错位28h回放',
            //     key: 'mismatch_record_28h',
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     value(now = getNow()) {
            //         const dayBeforeYesterday = addDate(now, -2, 'day');
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(yesterday),
            //                 value: [
            //                     [formatDay(dayBeforeYesterday), '20:00:00'],
            //                     [formatDay(yesterday), '23:59:59'],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     divider: true,
            // },
            // {
            //     label: '28h农历同比',
            //     key: 'nl_tb_28h',
            //     specialCustomCompare,
            //     isShown: BetweenHour(0, 20),
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTimeKey: 'lunarYoy',
            //         };
            //     },
            // },
            // {
            //     label: '28h农历同比（今日晚8至今）',
            //     key: 'nl_tb_28h_today',
            //     isShown: BetweenHour(20, 24),
            //     specialCustomCompare,
            //     value(now = getNow()) {
            //         return {
            //             realtime: {
            //                 key: 'today',
            //                 day: formatDay(now),
            //                 value: ['20:00:00', formatTime(now)],
            //                 type: 'rangeTime',
            //             },
            //             compareTimeKey: 'lunarYoy',
            //         };
            //     },
            // },
            // {
            //     label: '28h农历同比（昨日晚8至今）',
            //     key: 'nl_tb_28h_yesterday',
            //     isShown: BetweenHour(20, 24),
            //     specialCustomCompare,
            //     value(now = getNow()) {
            //         const yesterday = addDate(now, -1, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(now),
            //                 value: [
            //                     [formatDay(yesterday), '20:00:00'],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTimeKey: 'lunarYoy',
            //         };
            //     },
            // },
            // {
            //     divider: true,
            // },
            // {
            //     label: '开门红累计',
            //     key: 'open_door_aggr',
            //     isShown: Between('2022-10-31 00:00:00', '2022-12-01 00:00:00'),
            //     isDisabled: Between('2022-10-31 00:00:00', '2022-10-31 20:00:00'),
            //     includes: showOpen_door_aggr,
            //     virtualPanel: true,
            //     // 显示选项描述
            //     description: () => {
            //         const now = getNow();
            //         return [
            //             {
            //                 current: now < parseTime('2022-11-13 23:59:59'),
            //                 range: [
            //                     formatDate(now, 'YYYY-MM-DD 00:00:00'),
            //                     formatDate(now, 'YYYY-MM-DD 23:59:59'),
            //                 ],
            //             },
            //         ];
            //     },
            //     recommend: [
            //         Between('2022-11-02 00:00:00', '2022-11-02 20:00:00'),
            //         Between('2022-11-03 00:00:00', '2022-11-03 20:00:00'),
            //         Between('2022-11-04 00:00:00', '2022-11-04 20:00:00'),
            //         Between('2022-11-05 00:00:00', '2022-11-05 20:00:00'),
            //         Between('2022-11-06 00:00:00', '2022-11-06 20:00:00'),
            //         Between('2022-11-07 00:00:00', '2022-11-07 20:00:00'),
            //         Between('2022-11-08 00:00:00', '2022-11-08 20:00:00'),
            //         Between('2022-11-09 00:00:00', '2022-11-09 20:00:00'),
            //         Between('2022-11-10 00:00:00', '2022-11-10 20:00:00'),
            //         Between('2022-11-12 00:00:00', '2022-11-13 00:00:00'),
            //         Between('2022-11-13 00:00:00', '2022-11-14 00:00:00'),
            //     ],
            //     value(now = getNow()) {
            //         const start = parseTime('2022-10-31 20:00:00');
            //         const max = parseTime('2022-11-13 23:59:59');
            //         const end = now < max ? now : max;
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(start),
            //                 value: [
            //                     [formatDay(start), formatTime(start)],
            //                     [formatDay(end), formatTime(end)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '开门红累计（测试用）',
            //     key: 'open_door_aggr',
            //     itemKey: 'open_door_aggr_test',
            //     isShown: Between('2022-09-30 00:00:00', '2022-12-01 00:00:00'),
            //     includes: showOpen_door_aggr && debugMode,
            //     virtualPanel: true,
            //     value(now = getNow()) {
            //         const start = parseTime('2022-09-30 20:00:00');
            //         const max = parseTime('2022-11-12 23:59:59');
            //         const end = now < max ? now : max;
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(start),
            //                 value: [
            //                     [formatDay(start), formatTime(start)],
            //                     [formatDay(end), formatTime(end)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //         };
            //     },
            // },
            // {
            //     divider: true,
            // },
            // {
            //     label: '22-114 vs 21-116（测试用）',
            //     key: '22-114_vs_21-116',
            //     includes: debugMode,
            //     value(now = getNow()) {
            //         const start = parseTime('2022-11-04 20:00:00');
            //         const yoyStart = parseTime('2021-11-06 20:00:00');
            //         const yoyEnd = addDate(now, -363, 'day');
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 day: formatDay(start),
            //                 value: [
            //                     [formatDay(start), formatTime(start)],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTime: {
            //                 key: 'customCompare',
            //                 type: 'rangeDayTime',
            //                 value: [
            //                     [formatDay(yoyStart), formatTime(yoyStart)],
            //                     [formatDay(yoyEnd), formatTime(yoyEnd)],
            //                 ],
            //             },
            //         };
            //     },
            // },
            // {
            //     label: '22-115 vs 21-116',
            //     key: '22-115_vs_21-116',
            //     isShown: Between('2022-11-05 00:00:00', '2022-11-06 23:59:59'),
            //     isDisabled: Between('2022-11-05 00:00:00', '2022-11-05 20:00:00'),
            //     recommend: [Between('2022-11-05 20:00:00', '2022-11-06 23:59:59')],
            //     // 显示选项描述
            //     description: () => [
            //         {
            //             current: true,
            //             ahead: true,
            //             range: ['2022-11-05 20:00:00', '2022-11-06 05:59:59'],
            //         },
            //         {
            //             current: true,
            //             range: ['2022-11-06 06:00:00', '2022-11-06 23:59:59'],
            //         },
            //     ],
            //     value(now = getNow()) {
            //         const start = parseTime('2022-11-05 20:00:00');
            //         const ahead = inTimeRange(['2022-11-05 20:00:00', '2022-11-06 05:59:59'], now);
            //         let yoyStart = parseTime('2021-11-06 20:00:00');
            //         let yoyEnd = addDate(now, -364, 'day');
            //
            //         if (ahead) {
            //             yoyStart = addDate(yoyStart, 4, 'hour');
            //             yoyEnd = addDate(yoyEnd, 4, 'hour');
            //         }
            //
            //         return {
            //             realtime: {
            //                 key: 'custom',
            //                 valueKey: ahead ? 'ahead' : null,
            //                 day: formatDay(start),
            //                 value: [
            //                     [formatDay(start), formatTime(start)],
            //                     [formatDay(now), formatTime(now)],
            //                 ],
            //                 type: 'rangeDayTime',
            //             },
            //             compareTime: {
            //                 key: 'customCompare',
            //                 type: 'rangeDayTime',
            //                 value: [
            //                     [formatDay(yoyStart), formatTime(yoyStart)],
            //                     [formatDay(yoyEnd), formatTime(yoyEnd)],
            //                 ],
            //             },
            //         };
            //     },
            // },
        ]
            .filter(({includes, excludes}) => includes !== false && excludes !== true)
            // 为所有选项添加默认的key，
            .map(item => ({
                ...item,
                itemKey: item.itemKey ?? item.key ?? item.label,
            })),
    };
}
